import React from "react";
import ModalBase from "../../../components/modals/ModalBase";
import TextInputComp from "../../../components/inputs/TextInputComp";
import Button from "../../../components/buttons/Button";

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  editExamName: string;
  setEditExamName: (name: string) => void;
  onUpdateExam: () => void;
  loading: boolean;
};

const EditExamModal = ({
  isOpen,
  onClose,
  editExamName,
  setEditExamName,
  onUpdateExam,
  loading,
}: TProps) => {
  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Edit Exam Name">
      <div className="p-6 space-y-4">
        <TextInputComp
          label="Exam Name"
          value={editExamName}
          onChange={(e) => setEditExamName(e.target.value)}
        />
        <div className="flex justify-end gap-3">
          <Button title="Cancel" secondary onClick={onClose} />
          <Button
            title="Save Changes"
            onClick={onUpdateExam}
            loading={loading}
          />
        </div>
      </div>
    </ModalBase>
  );
};

export default EditExamModal;
